module.exports = __webpack_public_path__ + "static/img/icon-menu1.b6495b3f.svg";